import { RouterManager } from '@aclass/admin/managers';
import { SettingsStory } from '@aclass/admin/storage/actions';
import { IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class DateFormattingEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:date-formatting-edit';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<boolean>(['settingsModule', 'editDateFormattingPageInitialized']).pipe(filter((v: boolean) => v));
        this.employee = this.routerManager.onRejectNavigation(DateFormattingEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(SettingsStory.dryRunEditDateFormattingPage());
    }
}
